<template>
    <b-button v-b-tooltip.hover.focus="{title: description, customClass: 'object-access-help-tooltip'}" type="button" variant="link" size="sm" class="object-access-help" aria-label="Кто такие имеющие доступ" @click.stop.prevent="$event.currentTarget.focus()"><i class="far fa-question-circle" aria-hidden="true"/></b-button>
</template>
<script>
export default {
    data: () => ({description: 'Дополнительные сотрудники (как правило дополнительные мастера и прорабы на объекте), которым нужен доступ к объекту в Аргусе, помимо основного прораба и куратора. Доступные разделы и действия зависят от настроенных прав сотрудника. Поле необязательное, необходимость его заполнения уточняйте у куратора. Состав для добавления в Telegram проверяется отдельно в разделе ниже.'})
};
</script>
<style scoped>
.object-access-help {display: inline-flex; align-items: center; justify-content: center; width: 28px; height: 28px; padding: 0; margin-left: 3px; color: #416d96; font-size: 16px; vertical-align: middle;}
.object-access-help:hover, .object-access-help:focus {color: #174e84; text-decoration: none;}
@media (pointer: coarse) {.object-access-help {width: 36px; height: 36px;}}
</style>
<style>
.object-access-help-tooltip .tooltip-inner {max-width: 320px; text-align: left;}
@media (max-width: 575.98px) {.object-access-help-tooltip .tooltip-inner {max-width: calc(100vw - 32px);}}
</style>
